/**
 * FAQItem — single question/answer disclosure.
 */
import React, { useState } from 'react';
import { COLOR, FONT, RADIUS } from '../../../components/ss/tokens';

export default function FAQItem({ q, a, defaultOpen = false }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div
      style={{
        border: `1px solid ${COLOR.grayBorder}`,
        borderRadius: RADIUS.md,
        background: '#fff',
        overflow: 'hidden',
      }}
    >
      <button
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        style={{
          width: '100%',
          textAlign: 'left',
          background: 'transparent',
          border: 'none',
          cursor: 'pointer',
          padding: '18px 20px',
          display: 'flex',
          alignItems: 'center',
          gap: 16,
          fontSize: FONT.size.md,
          fontWeight: FONT.weight.semi,
          color: COLOR.text,
        }}
      >
        <span style={{ flex: 1 }}>{q}</span>
        <span
          aria-hidden
          style={{
            color: COLOR.blue,
            fontSize: 18,
            transform: open ? 'rotate(45deg)' : 'rotate(0)',
            transition: 'transform .15s',
          }}
        >
          +
        </span>
      </button>
      {open && (
        <div
          style={{
            padding: '0 20px 20px',
            fontSize: FONT.size.md,
            lineHeight: 1.6,
            color: COLOR.textMuted,
          }}
        >
          {a}
        </div>
      )}
    </div>
  );
}
